import { render, staticRenderFns } from "./PrintingContractor.vue?vue&type=template&id=b4946c3c&scoped=true&"
import script from "./PrintingContractor.vue?vue&type=script&lang=js&"
export * from "./PrintingContractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4946c3c",
  null
  
)

export default component.exports